var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubSectionDropDownArrow = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left-arrow 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.00254 7.15544L1.51317 2.66626C1.38985 2.54265 1.22498 2.47466 1.04917 2.47466C0.873268 2.47466 0.708488 2.54265 0.584976 2.66626L0.191805 3.05963C0.0680976 3.18304 0 3.34802 0 3.52383C0 3.69963 0.0680976 3.86441 0.191805 3.98792L5.53678 9.333C5.66068 9.457 5.82624 9.5249 6.00224 9.52441C6.17902 9.5249 6.34439 9.45709 6.46839 9.333L11.8082 3.9929C11.9319 3.86939 12 3.70461 12 3.5287C12 3.3529 11.9319 3.18812 11.8082 3.06451L11.415 2.67124C11.1591 2.41534 10.7425 2.41534 10.4867 2.67124L6.00254 7.15544Z",
    fill: "#0E0E23"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubSectionDropDownArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/subSectionDropDownArrow.b042462ea6ae59ac888faf8b547f7d6d.svg";